
import { defineComponent, ref } from 'vue';
import Upload from './Upload.vue';

export default defineComponent({
  components: {
    Upload,
  },
  props: {
    media: { type: Boolean, default: false },
  },
  emits: ['changed', 'finished'],
  setup(props, { emit }) {
    const active = ref(1);
    const ids = ref<Array<number>>([]);

    const onChanged = () => {
      emit('changed', ids.value);
    };

    const onFinished = (id: number) => {
      active.value++;
      ids.value.push(id);
      onChanged();
      emit('finished', id);
    };
    const onDeleted = (id: number) => {
      ids.value = ids.value.filter((item: number) => item != id);
      onChanged();
    };

    return {
      active,
      onChanged,
      onFinished,
      onDeleted,
    };
  },
});
